export const UCD_LIST = 'UCD_LIST';
export const UCD_VIEW = 'UCD_VIEW';
export const ADD_CASE = 'ADD_CASE';
export const CASE_LIST = 'CASE_LIST';
export const CASE_BY_ID = 'CASE_BY_ID';
export const CAR_BRAND = 'CAR_BRAND';
export const CAR_MODEL = 'CAR_MODEL';
export const CAR_VARIANT = 'CAR_VARIANT';
export const BANK_LIST = 'BANK_LIST';
export const CASES_BY_LSQ_DEALER_ID = 'CASES_BY_LSQ_DEALER_ID';
export const CASES_STATUS_UPDATE = 'CASES_STATUS_UPDATE';
export const LOAN_APPLICATION_BY_ID = 'LOAN_APPLICATION_BY_ID';
export const LOAN_APPLICATION_UPDATE = 'LOAN_APPLICATION_UPDATE';
export const PAYMENT_RAISE = 'PAYMENT_RAISE';
export const LOAN_ACCOUNTS = 'LOAN_ACCOUNTS';
export const LOAN_UNDERTAKING = 'LOAN_UNDERTAKING';
export const LOAN_TRANCHES = 'LOAN_TRANCHES';
export const LOAN_PAYMENT_REQUEST = 'LOAN_PAYMENT_REQUEST';
export const UPDATE_TRANCHE_STATUS = 'UPDATE_TRANCHE_STATUS';
export const PAYMENT_RAISE_UPDATE = 'PAYMENT_RAISE_UPDATE';
export const ACCOUNT_PENNY_DROP = 'ACCOUNT_PENNY_DROP';
export const APPROVAL_REQUEST = 'APPROVAL_REQUEST';
export const BANK_SHEET_UPLOAD = 'BANK_SHEET_UPLOAD';
export const GET_PAYOUT_DETAILS = 'GET_PAYOUT_DETAILS';
export const UPDATE_PAYOUT_DETAILS = 'UPDATE_PAYOUT_DETAILS';
export const GET_ACCOUNT_DETAILS = 'GET_ACCOUNT_DETAILS';
export const NEW_BANK_DETAILS = 'NEW_BANK_DETAILS';
export const PAYOUT_CONFIGURATION_LIST = 'PAYOUT_CONFIGURATION_LIST';
export const PAYOUT_CONFIGURATION_VERIFY = 'PAYOUT_CONFIGURATION_VERIFY';
export const B2C_LEAD = 'B2C_LEAD';
export const FORE_CLOSURE_ACCOUNT = 'FORE_CLOSURE_ACCOUNT';
export const VEHICLE_DETAILS = 'VEHICLE_DETAILS';
export const UPDATE_LOAN_APPLICATION_FOR_B2C = 'UPDATE_LOAN_APPLICATION_FOR_B2C';
export const B2C_CASE_LOGIN_WITHOUT_DEALER = 'B2C_CASE_LOGIN_WITHOUT_DEALER';
export const RC_CASE_LISTING = 'RC_CASE_LISTING';
export const RC_CASE_BY_ID = 'RC_CASE_BY_ID';
export const RTO_DETAILS_UPDATE = 'RTO_DETAILS_UPDATE';
export const COMMISSION_PAYOUT_CASE_LIST = 'COMMISSION_PAYOUT_CASE_LIST';
export const VALIDATE_INVOICE_STATUS = 'VALIDATE_INVOICE_STATUS';
export const PREVIEW_INVOICE = "PREVIEW_INVOICE";
export const RAISE_INVOICE = "RAISE_INVOICE";
export const CAR_BRAND_FOR_B2C = "CAR_BRAND_FOR_B2C";
export const CAR_MODEL_FOR_B2C = "CAR_MODEL_FOR_B2C";